import React from 'react';

import { OverflowAvatarStack } from '../OverflowAvatarStack';
import { REPORTING_LINES_USER_CARD_SLOTS_LIMIT } from '../ReportingLinesChart';
import { MissingProfileCard } from '../ReportingLinesUserCard';
import * as Styled from '../styles';
import { type ReportingLinesUser } from '../types';

import { renderReportingLinesUserCard, ReportingLinesUserCardWithLine } from './shared';
import { getUsersForLayoutSections } from './util';

interface DirectReportsSectionProps {
	selectedUser: ReportingLinesUser;
	directReports: ReportingLinesUser[];
	showAvatarStack: boolean;
	toggleAvatarStack: () => void;
}

export const DirectReportsSection = ({
	selectedUser,
	directReports,
	showAvatarStack,
	toggleAvatarStack,
}: DirectReportsSectionProps): React.JSX.Element => {
	const { usersForCards, usersForAvatarStack, numMissingProfiles } = getUsersForLayoutSections(
		directReports,
		showAvatarStack ? REPORTING_LINES_USER_CARD_SLOTS_LIMIT : undefined,
	);

	return (
		<>
			<ReportingLinesUserCardWithLine user={selectedUser} selected testId="selected-user-card" />
			<Styled.ReportsList testId="direct-reports-section">
				{usersForCards.map((user, index) => (
					<Styled.ReportsListItem key={user.accountIdentifier || `direct-report-${index}`}>
						{renderReportingLinesUserCard(user, `direct-report-${index}`)}
					</Styled.ReportsListItem>
				))}
				{!usersForAvatarStack && numMissingProfiles > 0 && (
					<Styled.ReportsListItem>
						<MissingProfileCard
							numMissingProfiles={numMissingProfiles}
							testId="missing-reports-card"
						/>
					</Styled.ReportsListItem>
				)}
				{usersForAvatarStack && (
					<Styled.ReportsListItem>
						<Styled.ReportsStackContainer>
							<OverflowAvatarStack
								atlassianUsers={usersForAvatarStack}
								numFilteredMissingProfiles={numMissingProfiles}
								onClick={toggleAvatarStack}
							/>
						</Styled.ReportsStackContainer>
					</Styled.ReportsListItem>
				)}
			</Styled.ReportsList>
		</>
	);
};
